import './project.css';
import MyImage from './images/ai.png'
import MyImage1 from './images/crypto.png'
import MyImage2 from './images/firewatch.png'
import { Link } from 'react-router-dom';

function TextBlock() {
    return (
        <div id="textblock">
            <div id="textblock-container">
                <div className='row flex flex-row'>
                    <div className='col-md-6 w-full'>
                    <h1 id="textblock-title" className='-mt-20'>Projects </h1>
            
                    </div>
                    <div className='col-md-6 -mt-28'>
                    <Link to="/" className='flex items-center justify-center pl-4 pt-12  '><button className='bg-gradient-to-r bg-yellow-400  hover:bg-red-600   h-10 w-28 rounded-full font-bold tracking-widest'><span className='bg-transparent font-bold'>&lt;</span> Home</button></Link>

                    </div>
                </div>

                <div className="h-auto justify-between row flex-col md:flex-row lg:flex-row xl:flex-row bg-transparent flex ">
                    <Link className='col-md-4 hover:shadow-lg w-full ' to="/">
                        <div className="w-full bg-[#3A3A3A] rounded-lg shadow-md lg:max-w-sm">
                            <img
                                className="object-cover w-full h-48"
                                src={MyImage}
                                alt="img"
                            />
                            <div className="p-1">
                                <h4 className="text-xl font-semibold tracking-wider text-yellow-400">
                                    AI Image Generator
                                </h4>
                                <p className=" leading-normal text-black tracking-wider text-justify">
                                    A Community Showcase to generate and share Images with text prompts.
                                </p>
                                <p className='text-black font-semibold tracking-wider text-justify'>
                                    Tech Stack: React, Tailwind CSS, NodeJs, Cloudinary, Dall-E API
                                </p>

                            </div>
                        </div>
                    </Link>

                    <Link className='col-md-4  w-full hover:shadow-lg' to="https://xcrypto-tracker.netlify.app/">
                        <div className="w-full bg-[#3A3A3A] rounded-lg shadow-md lg:max-w-sm">
                            <img
                                className="object-cover w-full h-48"
                                src={MyImage1}
                                alt="img"
                            />
                            <div className="p-1">
                                <h4 className="text-xl font-semibold tracking-wider text-yellow-400">
                                    Crypto Currency Price Tracker
                                </h4>
                                <p className=" leading-normal text-black tracking-wider text-justify">
                                The website offers real-time price updates and interactive graphs for over 50 cryptocurrencies.
                                </p>
                                <p className='text-black font-semibold tracking-wider text-justify'>
                                    Tech Stack: ReactJs, Tailwind CSS, Coingecko API
                                </p>

                            </div>
                        </div>
                    </Link>

                    <Link className='col-md-4  w-full hover:shadow-lg' to="/">
                        <div className="w-full bg-[#3A3A3A] rounded-lg shadow-md lg:max-w-sm">
                            <img
                                className="object-cover w-full h-48"
                                src="https://www.thetechedvocate.org/wp-content/uploads/2023/03/26-1.jpg"
                                alt="img"
                            />
                            <div className="p-1">
                                <h4 className="text-xl font-semibold tracking-wider text-yellow-400">
                                    Meme Share
                                </h4>
                                <p className=" leading-normal text-black tracking-wider text-justify">
                                Android App facilitating seamless sharing of Reddit-powered memes, fostering laughter and connection among users.
                                </p>
                                <p className='text-black font-semibold tracking-wider text-justify'>
                                    Tech Stack: React-native, Expo, Reddit API
                                </p>

                            </div>
                        </div>
                    </Link>


                </div>

                <div className="h-auto mt-8 justify-between row flex-col md:flex-row lg:flex-row xl:flex-row bg-transparent flex ">
                    <Link className='col-md-4 hover:shadow-lg w-full ' to="/">
                        <div className="w-full bg-[#3A3A3A] rounded-lg shadow-md lg:max-w-sm">
                            <img
                                className="object-cover w-full h-48"
                                src="https://www.simplilearn.com/ice9/free_resources_article_thumb/What_is_a_PMIS.jpg" alt="img"
                            />
                            <div className="p-1">
                                <h4 className="text-xl font-semibold tracking-wider text-yellow-400">
                                    Project Management System
                                </h4>
                                <p className=" leading-normal text-black tracking-wider text-justify">
                                Building a PMS for streamlining allocation and enhancing Project in Colleges.
                                </p>
                                <p className='text-black font-semibold tracking-wider text-justify'>
                                    Tech Stack: PHP, Laravel, SQL as Database, Bootstrap
                                </p>

                            </div>
                        </div>
                    </Link>

                    <Link className='col-md-4  w-full hover:shadow-lg' to="https://github.com/Bib3k4u/firebasetodo">
                        <div className="w-full bg-[#3A3A3A] rounded-lg shadow-md lg:max-w-sm">
                            <img
                                className="object-cover w-full h-48"
                                src="https://w7.pngwing.com/pngs/972/511/png-transparent-todo-sketch-note-list-tasks-thumbnail.png"
                                alt="img"
                            />
                            <div className="p-1">
                                <h4 className="text-xl font-semibold tracking-wider text-yellow-400">
                                    Todo Application
                                </h4>
                                <p className=" leading-normal text-black tracking-wider text-justify">
                                    A Todo Android Application to keep track of your daily tasks.
                                </p>
                                <p className='text-black font-semibold tracking-wider text-justify'>
                                    Tech Stack: React-Native, FireBase, Expo, react-bootstrap
                                </p>

                            </div>
                        </div>
                    </Link>

                    <Link className='col-md-4  w-full hover:shadow-lg' to="/">
                        <div className="w-full bg-[#3A3A3A] rounded-lg shadow-md lg:max-w-sm">
                            <img
                                className="object-cover w-full h-48"
                                src={MyImage2}
                                alt="img"
                            />
                            <div className="p-1">
                                <h4 className="text-xl font-semibold tracking-wider text-yellow-400">
                                    FireWatch
                                </h4>
                                <p className=" leading-normal text-black tracking-wider text-justify">
                                    A Parallax Website using React-Spring that provides 3-D experience on Scrolling
                                </p>
                                <p className='text-black font-semibold tracking-wider text-justify'>
                                    Tech Stack: ReactJs, Tailwind CSS, Bootstrap, React-Spring
                                </p>

                            </div>
                        </div>
                    </Link>


                </div>

            </div>
        </div>
    );
}

export default TextBlock;